import React, {Component} from 'react';
import {Message, Table} from 'semantic-ui-react';

class NoData extends Component {
  render() {
    return (
      <Table.Row>
        <Table.Cell colSpan={this.props.colSpan}>
          <Message
            icon='bell'
            header='No hay información registrada'/>
        </Table.Cell>
      </Table.Row>
    );
  }
}

export default NoData;



// WEBPACK FOOTER //
// ./src/components/extras/NoData.js